import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { companyLicenseFeaturesSchema } from '../schemas/company-license-features.schema';
import { fromFetch } from 'rxjs/fetch';

export function getCompanyLicenseFeatures(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).companyLicenseFeaturesUrl}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(companyLicenseFeaturesSchema));
}
